import { h} from 'preact';
import { useState } from 'preact/hooks';
import { Text } from 'preact-i18n';
import Markup from 'preact-markup';
import Carousel from 'preact-flickity-component'
import '../../../node_modules/flickity/dist/flickity.css'
import HtmlToText from 'html-to-text';
import { GetSafeImageUrl } from '../../utils/ApiUtil';

export const OneNews = props => {
  const [newsBlock, setNewsBlock] = useState(props.newsBlock);
  let maxLength = 80;
  let height = 110;
  let width = newsBlock.image ? Math.round(height * newsBlock.image.thumbnail.width / newsBlock.image.thumbnail.height) : 0;
  if(width < 190) {
    width = 190;
    height = newsBlock.image ? Math.round(width * newsBlock.image.thumbnail.height / newsBlock.image.thumbnail.width) : 0;
  }
  let title = HtmlToText.htmlToText(newsBlock.name);
  let description = (newsBlock.description) ? newsBlock.description: "";

  // for now, don't bother showing the images
  if(!newsBlock.image) {
    return "";
  }
  return (
    <a href={newsBlock.url}>
      <div className="ae-border-box-np news-block">
        <div className="news-top">
            <div className="block-img">
              {newsBlock.image ? (
                <img src={GetSafeImageUrl(newsBlock.image.thumbnail.contentUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={title} alt={title} />
              ):(
                <Markup markup={title} type="html" trim={false}/>
              )}
            </div>
        </div>
        <div className="news-description">
          <Markup markup={description} type="html" trim={false} className="ae-line-clamp-3"/>
        </div>
      </div>
    </a>
  )
}
export const HowLongAgo = props => {
  let ret = [];
  let when = props.when;

  if(!when) return "";

  let diff = new Date().getTime() - when.getTime();
  // start with days
  let daysago = Math.floor(diff/(1000*60*60*24));
  let hoursago = Math.floor(diff/(1000*60*60));
  let minsago = Math.floor(diff/(1000*60));
  var [id, len, txt] = ['', 0, ''];

  if(!props.short) {
    [id, len, txt] = daysago > 1 ? ['newSearch.daysago', daysago, `${daysago} days ago`]
                    : daysago === 1 ? ['newSearch.dayago', daysago, `${daysago} day ago`]
                    : hoursago > 1 ? ['newSearch.hoursago', hoursago, `${daysago} hours ago`]
                    : hoursago === 1 ? ['newSearch.hourago', hoursago, `${daysago} hour ago`]
                    : minsago > 1 ? ['newSearch.minsago', minsago, `${daysago} minutes ago`]
                    : minsago === 1 ? ['newSearch.minago', minsago, `${daysago} minute ago`]
                    : ['newSearch.breakingnews', 0, 'Breaking News'];
  } else {
    [id, len, txt] = daysago > 1 ? ['newSearch.shortdaysago', daysago, `${daysago}d`]
                    : daysago === 1 ? ['newSearch.shortdayago', daysago, `${daysago}d`]
                    : hoursago > 1 ? ['newSearch.shorthoursago', hoursago, `${daysago}h`]
                    : hoursago === 1 ? ['newSearch.shorthourago', hoursago, `${daysago}h`]
                    : minsago > 1 ? ['newSearch.shortminsago', minsago, `${daysago}m`]
                    : minsago === 1 ? ['newSearch.shortminago', minsago, `${daysago}m`]
                    : ['newSearch.shortbreakingnews', 0, 'Now'];
  }

  return (<span>(<Text id={id} fields={{len: len}}>{txt}</Text>)</span>);
}

export const OneNewsSnippets = props => {
  const [newsBlock, setNewsBlock] = useState(props.newsBlock);
  let height = 112;
  let width = newsBlock.image ? Math.round(height * newsBlock.image.thumbnail.width / newsBlock.image.thumbnail.height) : 0;
  if(width < 112) {
    width = 112;
    height = newsBlock.image ? Math.round(width * newsBlock.image.thumbnail.height / newsBlock.image.thumbnail.width) : 0;
  }
  let title = HtmlToText.htmlToText(newsBlock.name);
  let when = new Date(newsBlock.datePublished);
  let providers = newsBlock.provider;
  let provider = providers && providers.length > 0 ? providers[0] : null;
  let providerurl = provider && provider.image ? provider.image.thumbnail.contentUrl : null;
  let providername = provider && provider.name ? provider.name : null;
  let ago = "now";

  let newsSnippetClass = props.snippetType === "small" ? "ae-border-box news-snippet-sm" : "ae-border-box news-snippet";
  return (
    <a href={newsBlock.url} target="_blank" className="ae-dark">
      <div className={newsSnippetClass}>
        <div className="news-snippet-left">
          <div className="news-snippet-block">
            <div className="ae-caption ae-blue-text news-source-when">
              <div className="row">
                <span>{providerurl ? (<img src={GetSafeImageUrl(providerurl)} height='16' width='16'/>) : ({})}</span>
                <span><Markup markup={providername} type="html" trim={false}/></span>
              </div>
              <div className="row">
                {newsBlock.category ? (<span>/&nbsp;{newsBlock.category}&nbsp;</span>) : ""}
                <span>{when ? <HowLongAgo when={when} short={true}/> : ""}</span>
              </div>
            </div>
            <div className="ae-subtitle-large news-title"><Markup markup={newsBlock.name} trim={false} className="ae-line-clamp-2"/></div>
            <div className="ae-para news-details">
              <Markup markup={newsBlock.description} type="html" trim={false} className="ae-line-clamp-5"/>
            </div>
          </div>
        </div>
        <div className="news-snippet-right">
          <div className="snippet-image">
            {newsBlock.image ? (
              <img src={GetSafeImageUrl(newsBlock.image.thumbnail.contentUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={title} alt={title} />):({})}
          </div>
        </div>
      </div>
    </a>
  )
}
export const News = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);

  if(!item || !item.value || !item.value.id || item.answerType !== "News") {
    return (""); //defensive check
  }
  let newsBlocks = (searchResp.news && searchResp.news.id === item.value.id) ? searchResp.news.value : null;
  if(newsBlocks === null) {
    return (""); //defensive check
  }
  return (
    <div className="result-block">
      <div className="result-title">News about {query}</div>
      <div className="result-news">
        {newsBlocks.map(newsBlock => {
          return <OneNewsSnippets newsBlock={newsBlock} />
        })}
      </div>
    </div>
  )
}
export const NewsCarousel = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  const [affid, setAffid] = useState(props.affid);

  if(!item || !item.value || !item.value.id || item.answerType !== "News") {
    return (""); //defensive check
  }
  let newsBlocks = (searchResp.news && searchResp.news.id === item.value.id) ? searchResp.news.value : null;
  if(newsBlocks === null) {
    return (""); //defensive check
  }
  return (
    <div className="result-block">
      <div className="ae-title result-title"><Text id="newSearch.news">News</Text></div>
      <div className="ae-caption see-more-link">
        <a href={`/search?q=${encodeURIComponent(query)}&service=news&affid=${encodeURIComponent(affid)}`}><Text id="newSearch.seeMoreNews">See more news</Text></a>
      </div>
      <Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: props.isRightToLeft ? 'right' : 'left', rightToLeft: props.isRightToLeft}}>
        {newsBlocks.map(newsBlock => {
          return <OneNews newsBlock={newsBlock} />
        })}
      </Carousel>
    </div>
  )
}
